import React, {useEffect, useState} from "react";
import {nonObject} from "../../../../components/commonmethod/CommonMethod";

function UserAccountManageSearchBar({saveConditions, handleSearch, detailButton, placeholder = "이름"}) {
    const [searchTxt, setSearchTxt] = useState(saveConditions?.searchTxt ?? "");

    useEffect(() => {
        setSearchTxt(saveConditions?.searchTxt ?? "");
    }, [saveConditions?.searchTxt]);

    const submitSearch = () => {
        nonObject(saveConditions, searchTxt, handleSearch, "searchTxt");
    };

    return (
        <div className="user-account-manage-search">
            <div className="user-account-manage-search__input-slot">
                <input
                    type="text"
                    className="user-account-manage-search__input basic-input input-style"
                    placeholder={placeholder}
                    value={searchTxt}
                    onChange={(e) => setSearchTxt(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            submitSearch();
                        }
                    }}
                />
            </div>
            {detailButton ? (
                <div className="user-account-manage-search__detail">
                    {detailButton}
                </div>
            ) : null}
        </div>
    );
}

export default UserAccountManageSearchBar;
